
export function investorCategoryMap(key) {
  const map = {
    'INDV' : 'Individual',
    'CORP' : 'Corporation'
  }
  return map[key];
}

export function getInvestorCategory () {
  return [
    { name: 'Individual', value: 'INDV'},
    { name: 'Corporation', value: 'CORP'},
    { name: 'Individual - QIB', value: 'INDV - QIB'},
    { name: 'Individual - TRUST', value: 'INDV - TRUST'},
    { name: 'Corporation - QIB', value: 'CORP - QIB'},
    { name: 'Corporation - TRUST', value: 'CORP - TRUST'}
  ]
}

export function getTaxStatuses () {
  return [
    { name: 'NWT (Tax-Exempt 0%)', value: 'NWT' },
    { name: 'FTX (Taxable 20%)', value: 'FTX' },
    { name: 'FTXN (Taxable 25%)', value: 'FTXN' },
    { name: 'FMX1 (Taxable 30%)', value: 'FMX1' }
  ]
}

export function getSourcesOfIncome () {
  return [
    { name: 'Business', value: 'Business' },
    { name: 'Savings',  value: 'Savings'},
    { name: 'Inheritance', value: 'Inheritance' },
    { name: 'Donation', value: 'Donation' },
    { name: 'Employment/Salary', value: 'Employment/Salary' }
  ]
}

export function deliveryModesMap (key) {
  const map = {
    'D':'Deliver via Courier',
    'E':'Deliver via Email'
  }
  return map[key];
}

export function getDeliveryModes () {
  return [
    { name: 'Deliver via Courier', value: 'D' },
    { name: 'Deliver via Email', value: 'E' }
  ]
}

export function modeOfCollectionOfInterestMap(key) {
  const map = {
    "RTGS":"Real Time Gross Settlement (RTGS)",
    "CREDIT_SAVINGS_ACC_NUM":"Credit current/savings account number"
  };
  return map[key];
}

export function getModeOfCollectionOfInterests (key) {
  return [
    { name: 'Real Time Gross Settlement (RTGS)', value: 'RTGS' },
    { name: 'Credit current/savings account number', value: 'CREDIT_SAVINGS_ACC_NUM' }
  ];
}

export function modeOfPaymentsMap(key) {
  const map = {
    "RTGS": "Real Time Gross Settlement",
    "BANK_CHECK": "Regular Bank Check",
    "DIRECT_DEBIT": "Direct Debit",
    "BANK_BONDS" : "Bonds Exchange"
  }
  return map[key];
}

export function getModeOfPayments() {
  return [
    { name: 'Real Time Gross Settlement', value: 'RTGS' },
    { name: 'Regular Bank Check', value: 'BANK_CHECK' },
    { name: 'Direct Debit', value: 'DIRECT_DEBIT' },
    { name: 'Bank Bonds', value: 'BANK_BONDS' }
  ]
}

export function idTypesMap (key) {
  const map = {
    "PPTN":"Passport",
    "DRLN":"Driver's License",
    "NATD":"National ID",
    "TINN":"Tax Identification Number",
    "SSSN":"Social Security System ID",
    "GSIS":"Government Service Insurance System ID",
    "ACRN":"Alien Certificate of Registration",
    "PRCN":"Professional Regulation Comission ID",
    "NBIC":"NBI Clearance",
    "POLC":"Police Clearance",
    "POST":"Postal ID",
    "VOTE":"Voter's ID",
    "BRGY":"Baranggay Certification",
    "SRID":"Senior Citizen's Card",
    "OWWA":"OWWA ID",
    "OFWN":"Overseas Filipino Worker ID",
    "SEAB":"Seaman's Book",
    "IMIG":"Immigrant Certificate of Registration",
    "GOVT":"Government Office & GOCC Issued ID (E.G. AFP ID, HDMF ID)",
    "NCWD":"Certificate from the National Council for the Welfare of Disabled Persons",
    "DSWD":"Department of Social Welfare & Development Certification",
    "INTG":"Integrated Bar of the Philippines ID",
    "COMP":"Company IDs Issued by Private Entities or Institutions Registered with or Supervised or Regualted either by the BSP, SEC OR IC",
    "MARINA":"Maritime Industry Authority (MARINA)",
    "CRIC": "Certificate of Incorporation",
    "CMRN": "Registration Number",
    "PRPD": "Partnership Deed"
  };
  return map[key];
}

export function getIDTypes(investorType) {
  if(investorType === 'CORP'){
    return [
      {name: "Tax Identification Number", value: "TINN"},
      {name: "Certificate of Incorporation", value: "CRIC"},
      {name: "Registration Number", value: "CMRN"},
      {name: "Partnership Deed", value: "PRPD"}
    ]
  }
  return [
    {name: "Passport", value: "PPTN"},
    {name: "Driver's License", value: "DRLN"},
    {name: "National ID", value: "NATD"},
    {name: "Tax Identification Number", value: "TINN"},
    {name: "Social Security System ID", value: "SSSN"},
    {name: "Government Service Insurance System ID", value: "GSIS"},
    {name: "Alien Certificate of Registration", value: "ACRN"},
    {name: "Professional Regulation Comission ID", value: "PRCN"},
    {name: "NBI Clearance", value: "NBIC"},
    {name: "Police Clearance", value: "POLC"},
    {name: "Postal ID", value: "POST"},
    {name: "Voter's ID", value: "VOTE"},
    {name: "Baranggay Certification", value: "BRGY"},
    {name: "Senior Citizen's Card", value: "SRID"},
    {name: "OWWA ID", value: "OWWA"},
    {name: "Overseas Filipino Worker ID", value: "OFWN"},
    {name: "Seaman's Book", value: "SEAB"},
    {name: "Immigrant Certificate of Registration", value: "IMIG"},
    {name: "Government Office & GOCC Issued ID (E.G. AFP ID, HDMF ID)", value: "GOVT"},
    {name: "Certificate from the National Council for the Welfare of Disabled Persons", value: "NCWD"},
    {name: "Department of Social Welfare & Development Certification", value: "DSWD"},
    {name: "Integrated Bar of the Philippines ID", value: "INTG"},
    {name: "Company IDs Issued by Private Entities or Institutions Registered with or Supervised or Regualted either by the BSP, SEC OR IC", value: "COMP"},
    {name: "Maritime Industry Authority (MARINA)", value: "MARINA"}
  ]
}

export function securityRegistrationMap(key) {
  const map = {
    'APPLICANT_NAME': 'Under the name of the applicant',
    'PDTC_CORP': 'Under the name of PDTC Nominee Corp.'
  }
  return map[key];
}


export function getSecurityRegistrationOptions() {
  return [
    { name: 'Under the name of the applicant', value: 'APPLICANT_NAME' },
    { name: 'Under the name of PDTC Nominee Corp.', value: 'PDTC_CORP' }
  ]
}

export function bankListMap (key) {
  const map = {
    "SBAUB000000":"Asia United Bank",
    "BSPBANK0001":"Bangko Sentral ng Pilinas",
    "SBBDO000000":"Banco de Oro Unibank, Inc.",
    "SBBKCP00000":"Bank of Commerce",
    "SBBPI000000":"Bank of the Philippine Islands",
    "SBCHIB00000":"China Banking Corporation",
    "SBCTBC00000":"CTBC BANK (PHILIPPINES) CORP",
    "SBRDBP00000":"Development Bank of the Philippines",
    "SBREWB00000":"East West Banking Corporation",
    "SBHSBC00000":"HSBC",
    "SBLBP000000":"Land Bank of the Philippines",
    "SBMAYB00000":"Maybank Philippines INC",
    "SBRMBTC0000":"Metropolitan Bank & Trust Company",
    "SBPBCOM0000":"PHILIPPINE BANK OF COMMUNICATION",
    "SBRPNB00000":"Philippine National Bank",
    "SBPSB000000":"PHILIPPINE SAVINGS BANK",
    "SBRRCBC0000":"Rizal Commercial Banking Corporation",
    "SBRBC000000":"ROBINSONS BANK CORPORATION",
    "SBSBMN00000":"Security Bank",
    "SBSCB000000":"Standard Chartered Bank",
    "SBRSTERLING":"Sterling Bank of Asia, Inc.",
    "SBUBP000000":"UNION BANK OF THE PHILIPPINES",
    "SBUCPB00000":"United Coconut Planters Bank",
    "SBRBDOP0000":"BDO Private Bank"
  }
  return map[key];
}

export function getSettBankList () {
  return [
    {name: "Asia United Bank", value: "SBAUB000000"},
    {name: "Bangko Sentral ng Pilinas", value: "BSPBANK0001"},
    {name: "Banco de Oro Unibank, Inc.", value: "SBBDO000000"},
    {name: "Bank of Commerce", value: "SBBKCP00000"},
    {name: "Bank of the Philippine Islands", value: "SBBPI000000"},
    {name: "China Banking Corporation", value: "SBCHIB00000"},
    {name: "Development Bank of the Philippines", value: "SBRDBP00000"},
    {name: "East West Banking Corporation", value: "SBREWB00000"},
    {name: "HSBC", value: "SBHSBC00000"},
    {name: "Land Bank of the Philippines", value: "SBLBP000000"},
    {name: "Metropolitan Bank & Trust Company", value: "SBRMBTC0000"},
    {name: "Philippine National Bank", value: "SBRPNB00000"},
    {name: "Rizal Commercial Banking Corporation", value: "SBRRCBC0000"},
    {name: "Security Bank", value: "SBSBMN00000"},
    {name: "Standard Chartered Bank", value: "SBSCB000000"},
    {name: "Sterling Bank of Asia, Inc.", value: "SBRSTERLING"},
    {name: "United Coconut Planters Bank", value: "SBUCPB00000"},
    {name: "PHILIPPINE SAVINGS BANK", value: "SBPSB000000"},
    {name: "Maybank Philippines INC", value: "SBMAYB00000"},
    {name: "ROBINSONS BANK CORPORATION", value: "SBRBC000000"},
    {name: "UNION BANK OF THE PHILIPPINES", value: "SBUBP000000"},
    {name: "CTBC BANK (PHILIPPINES) CORP", value: "SBCTBC00000"},
    {name: "PHILIPPINE BANK OF COMMUNICATION", value: "SBPBCOM0000"},
    {name: "BDO Private Bank", value: "SBRBDOP0000"}
  ]
}

export function getPlaceList() {
  return [
    {name: "MNL - Metro Manila ", value: "MNL - Metro Manila "},
    {name: "ABR - Abra ", value: "ABR - Abra "},
    {name: "XXX - Not Philippines", value: "XXX - Not Philippines"},
    {name: "AGN - Agusan del Norte", value: "AGN - Agusan del Norte"},
    {name: "AGS - Agusan del Sur", value: "AGS - Agusan del Sur"},
    {name: "AKL - Aklan ", value: "AKL - Aklan "},
    {name: "ALB - Albay ", value: "ALB - Albay "},
    {name: "ANT - Antique ", value: "ANT - Antique "},
    {name: "APA - Apayao ", value: "APA - Apayao "},
    {name: "AUR - Aurora ", value: "AUR - Aurora "},
    {name: "BAN - Bataan ", value: "BAN - Bataan "},
    {name: "BAS - Basilan ", value: "BAS - Basilan "},
    {name: "BEN - Benguet ", value: "BEN - Benguet "},
    {name: "BIL - Biliran ", value: "BIL - Biliran "},
    {name: "BOH - Bohol ", value: "BOH - Bohol "},
    {name: "BTG - Batangas ", value: "BTG - Batangas "},
    {name: "BTN - Batanes ", value: "BTN - Batanes "},
    {name: "BUK - Bukidnon ", value: "BUK - Bukidnon "},
    {name: "BUL - Bulacan ", value: "BUL - Bulacan "},
    {name: "CAG - Cagayan ", value: "CAG - Cagayan "},
    {name: "CAM - Camiguin ", value: "CAM - Camiguin "},
    {name: "CAN - Camarines Norte ", value: "CAN - Camarines Norte "},
    {name: "CAP - Capiz ", value: "CAP - Capiz "},
    {name: "CAS - Camarines Sur ", value: "CAS - Camarines Sur "},
    {name: "CAT - Catanduanes ", value: "CAT - Catanduanes "},
    {name: "CAV - Cavite ", value: "CAV - Cavite "},
    {name: "CEB - Cebu ", value: "CEB - Cebu "},
    {name: "COM - Compostela Valley ", value: "COM - Compostela Valley "},
    {name: "DAC - Davao Occidental ", value: "DAC - Davao Occidental "},
    {name: "DAO - Davao Oriental ", value: "DAO - Davao Oriental "},
    {name: "DAS - Davao del Sur ", value: "DAS - Davao del Sur "},
    {name: "DAV - Davao del Norte ", value: "DAV - Davao del Norte "},
    {name: "EAS - Eastern Samar ", value: "EAS - Eastern Samar "},
    {name: "GUI - Guimaras ", value: "GUI - Guimaras "},
    {name: "IFU - Ifugao ", value: "IFU - Ifugao "},
    {name: "ILI - Iloilo ", value: "ILI - Iloilo "},
    {name: "ILN - Ilocos Norte ", value: "ILN - Ilocos Norte "},
    {name: "ILS - Ilocos Sur ", value: "ILS - Ilocos Sur "},
    {name: "ISA - Isabela ", value: "ISA - Isabela "},
    {name: "KAL - Kalinga ", value: "KAL - Kalinga "},
    {name: "LAG - Laguna ", value: "LAG - Laguna "},
    {name: "LAN - Lanao del Norte ", value: "LAN - Lanao del Norte "},
    {name: "LAS - Lanao del Sur ", value: "LAS - Lanao del Sur "},
    {name: "LEY - Leyte ", value: "LEY - Leyte "},
    {name: "LUN - La Union ", value: "LUN - La Union "},
    {name: "MAD - Marinduque ", value: "MAD - Marinduque "},
    {name: "MAG - Maguindanao ", value: "MAG - Maguindanao "},
    {name: "MAS - Masbate ", value: "MAS - Masbate "},
    {name: "MDC - Occidental Mindoro ", value: "MDC - Occidental Mindoro "},
    {name: "MDR - Oriental Mindoro ", value: "MDR - Oriental Mindoro "},
    {name: "MOU - Mountain Province", value: "MOU - Mountain Province"},
    {name: "MSC - Misamis Occidental ", value: "MSC - Misamis Occidental "},
    {name: "MSR - Misamis Oriental ", value: "MSR - Misamis Oriental "},
    {name: "NCO - Cotabato ", value: "NCO - Cotabato "},
    {name: "NEC - Negros Occidental", value: "NEC - Negros Occidental"},
    {name: "NER - Negros Oriental", value: "NER - Negros Oriental"},
    {name: "NSA - Northern Samar ", value: "NSA - Northern Samar "},
    {name: "NUE - Nueva Ecija ", value: "NUE - Nueva Ecija "},
    {name: "NUV - Nueva Vizcaya ", value: "NUV - Nueva Vizcaya "},
    {name: "PAM - Pampanga ", value: "PAM - Pampanga "},
    {name: "PAN - Pangasinan ", value: "PAN - Pangasinan "},
    {name: "PLW - Palawan ", value: "PLW - Palawan "},
    {name: "QUE - Quezon ", value: "QUE - Quezon "},
    {name: "QUI - Quirino ", value: "QUI - Quirino "},
    {name: "RIZ - Rizal ", value: "RIZ - Rizal "},
    {name: "ROM - Romblon ", value: "ROM - Romblon "},
    {name: "SAM - Samar ", value: "SAM - Samar "},
    {name: "SAR - Sarangani ", value: "SAR - Sarangani "},
    {name: "SCO - South Cotabato ", value: "SCO - South Cotabato "},
    {name: "SIG - Siquijor ", value: "SIG - Siquijor "},
    {name: "SLE - Southern Leyte ", value: "SLE - Southern Leyte "},
    {name: "SLU - Sulu ", value: "SLU - Sulu "},
    {name: "SOR - Sorsogon ", value: "SOR - Sorsogon "},
    {name: "SUK - Sultan Kudarat ", value: "SUK - Sultan Kudarat "},
    {name: "SUN - Surigao del Norte ", value: "SUN - Surigao del Norte "},
    {name: "SUR - Surigao del Sur ", value: "SUR - Surigao del Sur "},
    {name: "TAR - Tarlac ", value: "TAR - Tarlac "},
    {name: "TAW - Tawi-Tawi ", value: "TAW - Tawi-Tawi "},
    {name: "ZAN - Zamboanga del Norte ", value: "ZAN - Zamboanga del Norte "},
    {name: "ZAS - Zamboanga del Sur ", value: "ZAS - Zamboanga del Sur "},
    {name: "ZMB - Zambales", value: "ZMB - Zambales"},
    {name: "ZSI - Zamboanga Sibugay", value: "ZSI - Zamboanga Sibugay"},
    {name: "ZAB - Zamboanga Sibugay", value: "ZAB - Zamboanga Sibugay"}
  ]
}

export function getCountries() {
    return [
      {name: " PH - Philippines ", value: "PH - Philippines "},
      {name: " CN - China ", value: " CN - China "},
      {name: " US - United States ", value: " US - United States "},
      {name: " CA - Canada ", value: " CA - Canada "},
      {name: " AF - Afghanistan ", value: " AF - Afghanistan "},
      {name: " AL - Albania ", value: " AL - Albania "},
      {name: " DZ - Algeria ", value: " DZ - Algeria "},
      {name: " AS - American Samoa ", value: " AS - American Samoa "},
      {name: " AD - Andorra ", value: " AD - Andorra "},
      {name: " AO - Angola ", value: " AO - Angola "},
      {name: " AI - Anguilla ", value: " AI - Anguilla "},
      {name: " AQ - Antarctica ", value: " AQ - Antarctica "},
      {name: " AG - Antigua and Barbuda ", value: " AG - Antigua and Barbuda "},
      {name: " AR - Argentina ", value: " AR - Argentina "},
      {name: " AM - Armenia ", value: " AM - Armenia "},
      {name: " AW - Aruba ", value: " AW - Aruba "},
      {name: " AU - Australia ", value: " AU - Australia "},
      {name: " AT - Austria ", value: " AT - Austria "},
      {name: " AZ - Azerbaijan ", value: " AZ - Azerbaijan "},
      {name: " BS - Bahamas ", value: " BS - Bahamas "},
      {name: " BH - Bahrain ", value: " BH - Bahrain "},
      {name: " BD - Bangladesh ", value: " BD - Bangladesh "},
      {name: " BY - Belarus ", value: " BY - Belarus "},
      {name: " BE - Belgium ", value: " BE - Belgium "},
      {name: " BZ - Belize ", value: " BZ - Belize "},
      {name: " BJ - Benin ", value: " BJ - Benin "},
      {name: " BM - Bermuda ", value: " BM - Bermuda "},
      {name: " BT - Bhutan ", value: " BT - Bhutan "},
      {name: " BO - Bolivia ", value: " BO - Bolivia "},
      {name: " BA - Bosnia-Herzegovina ", value: " BA - Bosnia-Herzegovina "},
      {name: " BW - Botswana ", value: " BW - Botswana "},
      {name: " BV - Bouvet Island ", value: " BV - Bouvet Island "},
      {name: " BR - Brazil ", value: " BR - Brazil "},
      {name: " IO - British Indian Ocean Territories ", value: " IO - British Indian Ocean Territories "},
      {name: " BN - Brunei Darussalam ", value: " BN - Brunei Darussalam "},
      {name: " BG - Bulgaria ", value: " BG - Bulgaria "},
      {name: " BF - Burkina Faso ", value: " BF - Burkina Faso "},
      {name: " BI - Burundi ", value: " BI - Burundi "},
      {name: " KH - Cambodia ", value: " KH - Cambodia "},
      {name: " CM - Cameroon ", value: " CM - Cameroon "},
      {name: " CV - Cape Verde ", value: " CV - Cape Verde "},
      {name: " KY - Cayman Islands ", value: " KY - Cayman Islands "},
      {name: " CF - Central African Republic ", value: " CF - Central African Republic "},
      {name: " TD - Chad ", value: " TD - Chad "},
      {name: " CL - Chile ", value: " CL - Chile "},
      {name: " CX - Christmas Island ", value: " CX - Christmas Island "},
      {name: " CC - Cocos (Keeling) Islands ", value: " CC - Cocos (Keeling) Islands "},
      {name: " CO - Colombia ", value: " CO - Colombia "},
      {name: " KM - Comoros ", value: " KM - Comoros "},
      {name: " CD - Congo, Democratic Rep. ", value: " CD - Congo, Democratic Rep. "},
      {name: " CG - Congo, Republic of ", value: " CG - Congo, Republic of "},
      {name: " CK - Cook Islands ", value: " CK - Cook Islands "},
      {name: " CR - Costa Rica ", value: " CR - Costa Rica "},
      {name: " HR - Croatia ", value: " HR - Croatia "},
      {name: " CU - Cuba ", value: " CU - Cuba "},
      {name: " CY - Cyprus ", value: " CY - Cyprus "},
      {name: " CZ - Czech Republic ", value: " CZ - Czech Republic "},
      {name: " CS - Czechoslovakia ", value: " CS - Czechoslovakia "},
      {name: " DK - Denmark ", value: " DK - Denmark "},
      {name: " DJ - Djibouti ", value: " DJ - Djibouti "},
      {name: " DM - Dominica ", value: " DM - Dominica "},
      {name: " DO - Dominican Republic ", value: " DO - Dominican Republic "},
      {name: " TP - East Timor ", value: " TP - East Timor "},
      {name: " EC - Ecuador ", value: " EC - Ecuador "},
      {name: " EG - Egypt ", value: " EG - Egypt "},
      {name: " SV - El Salvador ", value: " SV - El Salvador "},
      {name: " GQ - Equatorial Guinea ", value: " GQ - Equatorial Guinea "},
      {name: " ER - Eritrea ", value: " ER - Eritrea "},
      {name: " EE - Estonia ", value: " EE - Estonia "},
      {name: " ET - Ethiopia ", value: " ET - Ethiopia "},
      {name: " FK - Falkland Islands (Malvinas) ", value: " FK - Falkland Islands (Malvinas) "},
      {name: " FO - Faroe Islands ", value: " FO - Faroe Islands "},
      {name: " FJ - Fiji ", value: " FJ - Fiji "},
      {name: " FI - Finland ", value: " FI - Finland "},
      {name: " FR - France ", value: " FR - France "},
      {name: " FX - France (European Territories) ", value: " FX - France (European Territories) "},
      {name: " TF - French Southern Territories ", value: " TF - French Southern Territories "},
      {name: " GA - Gabon ", value: " GA - Gabon "},
      {name: " GM - Gambia ", value: " GM - Gambia "},
      {name: " GE - Georgia ", value: " GE - Georgia "},
      {name: " DE - Germany ", value: " DE - Germany "},
      {name: " GH - Ghana ", value: " GH - Ghana "},
      {name: " GI - Gibraltar ", value: " GI - Gibraltar "},
      {name: " GB - Great Britain (UK) ", value: " GB - Great Britain (UK) "},
      {name: " GR - Greece ", value: " GR - Greece "},
      {name: " GL - Greenland ", value: " GL - Greenland "},
      {name: " GD - Grenada ", value: " GD - Grenada "},
      {name: " GP - Guadeloupe (Fr.) ", value: " GP - Guadeloupe (Fr.) "},
      {name: " GU - Guam (US) ", value: " GU - Guam (US) "},
      {name: " GT - Guatemala ", value: " GT - Guatemala "},
      {name: " GF - Guiana (Fr.) ", value: " GF - Guiana (Fr.) "},
      {name: " GN - Guinea ", value: " GN - Guinea "},
      {name: " GW - Guinea Bissau ", value: " GW - Guinea Bissau "},
      {name: " GY - Guyana ", value: " GY - Guyana "},
      {name: " HT - Haiti ", value: " HT - Haiti "},
      {name: " HM - Heard & McDonald Islands ", value: " HM - Heard & McDonald Islands "},
      {name: " HN - Honduras ", value: " HN - Honduras "},
      {name: " HK - Hong Kong ", value: " HK - Hong Kong "},
      {name: " HU - Hungary ", value: " HU - Hungary "},
      {name: " IS - Iceland ", value: " IS - Iceland "},
      {name: " IN - India ", value: " IN - India "},
      {name: " ID - Indonesia ", value: " ID - Indonesia "},
      {name: " IR - Iran ", value: " IR - Iran "},
      {name: " IQ - Iraq ", value: " IQ - Iraq "},
      {name: " IE - Ireland ", value: " IE - Ireland "},
      {name: " IL - Israel ", value: " IL - Israel "},
      {name: " IT - Italy ", value: " IT - Italy "},
      {name: " CI - Ivory Coast ", value: " CI - Ivory Coast "},
      {name: " JM - Jamaica ", value: " JM - Jamaica "},
      {name: " JP - Japan ", value: " JP - Japan "},
      {name: " JO - Jordan ", value: " JO - Jordan "},
      {name: " KZ - Kazakhstan ", value: " KZ - Kazakhstan "},
      {name: " KE - Kenya ", value: " KE - Kenya "},
      {name: " KI - Kiribati ", value: " KI - Kiribati "},
      {name: " KP - Korea (North) ", value: " KP - Korea (North) "},
      {name: " KR - Korea (South) ", value: " KR - Korea (South) "},
      {name: " KW - Kuwait ", value: " KW - Kuwait "},
      {name: " KG - Kyrgyz Republic ", value: " KG - Kyrgyz Republic "},
      {name: " LA - Laos ", value: " LA - Laos "},
      {name: " LV - Latvia ", value: " LV - Latvia "},
      {name: " LB - Lebanon ", value: " LB - Lebanon "},
      {name: " LS - Lesotho ", value: " LS - Lesotho "},
      {name: " LR - Liberia ", value: " LR - Liberia "},
      {name: " LY - Libya ", value: " LY - Libya "},
      {name: " LI - Liechtenstein ", value: " LI - Liechtenstein "},
      {name: " LT - Lithuania ", value: " LT - Lithuania "},
      {name: " LU - Luxembourg ", value: " LU - Luxembourg "},
      {name: " MO - Macau ", value: " MO - Macau "},
      {name: " MK - Macedonia (former Yuguslavia) ", value: " MK - Macedonia (former Yuguslavia) "},
      {name: " MG - Madagascar ", value: " MG - Madagascar "},
      {name: " MW - Malawi ", value: " MW - Malawi "},
      {name: " MY - Malaysia ", value: " MY - Malaysia "},
      {name: " MV - Maldives ", value: " MV - Maldives "},
      {name: " ML - Mali ", value: " ML - Mali "},
      {name: " MT - Malta ", value: " MT - Malta "},
      {name: " MH - Marshall Islands ", value: " MH - Marshall Islands "},
      {name: " MQ - Martinique (Fr.) ", value: " MQ - Martinique (Fr.) "},
      {name: " MR - Mauritania ", value: " MR - Mauritania "},
      {name: " MU - Mauritius ", value: " MU - Mauritius "},
      {name: " YT - Mayotte ", value: " YT - Mayotte "},
      {name: " MX - Mexico ", value: " MX - Mexico "},
      {name: " FM - Micronesia ", value: " FM - Micronesia "},
      {name: " MD - Moldova ", value: " MD - Moldova "},
      {name: " MC - Monaco ", value: " MC - Monaco "},
      {name: " MN - Mongolia ", value: " MN - Mongolia "},
      {name: " MS - Montserrat ", value: " MS - Montserrat "},
      {name: " MA - Morocco ", value: " MA - Morocco "},
      {name: " MZ - Mozambique ", value: " MZ - Mozambique "},
      {name: " MM - Myanmar ", value: " MM - Myanmar "},
      {name: " NA - Namibia ", value: " NA - Namibia "},
      {name: " NR - Nauru ", value: " NR - Nauru "},
      {name: " NP - Nepal ", value: " NP - Nepal "},
      {name: " AN - Netherland Antilles ", value: " AN - Netherland Antilles "},
      {name: " NL - Netherlands ", value: " NL - Netherlands "},
      {name: " NC - New Caledonia (Fr.) ", value: " NC - New Caledonia (Fr.) "},
      {name: " NZ - New Zealand ", value: " NZ - New Zealand "},
      {name: " NI - Nicaragua ", value: " NI - Nicaragua "},
      {name: " NE - Niger ", value: " NE - Niger "},
      {name: " NG - Nigeria ", value: " NG - Nigeria "},
      {name: " NU - Niue ", value: " NU - Niue "},
      {name: " NF - Norfolk Island ", value: " NF - Norfolk Island "},
      {name: " MP - Northern Mariana Islands ", value: " MP - Northern Mariana Islands "},
      {name: " NO - Norway ", value: " NO - Norway "},
      {name: " OM - Oman ", value: " OM - Oman "},
      {name: " PK - Pakistan ", value: " PK - Pakistan "},
      {name: " PW - Palau ", value: " PW - Palau "},
      {name: " PA - Panama ", value: " PA - Panama "},
      {name: " PG - Papua New Guinea ", value: " PG - Papua New Guinea "},
      {name: " PY - Paraguay ", value: " PY - Paraguay "},
      {name: " PE - Peru ", value: " PE - Peru "},
      {name: " PN - Pitcairn ", value: " PN - Pitcairn "},
      {name: " PL - Poland ", value: " PL - Poland "},
      {name: " PF - Polynesia (Fr.) ", value: " PF - Polynesia (Fr.) "},
      {name: " PT - Portugal ", value: " PT - Portugal "},
      {name: " PR - Puerto Rico (US) ", value: " PR - Puerto Rico (US) "},
      {name: " PS - Palestinian State ", value: " PS - Palestinian State "},
      {name: " QA - Qatar ", value: " QA - Qatar "},
      {name: " RE - Reunion (Fr.) ", value: " RE - Reunion (Fr.) "},
      {name: " RO - Romania ", value: " RO - Romania "},
      {name: " RU - Russian Federation ", value: " RU - Russian Federation "},
      {name: " RW - Rwanda ", value: " RW - Rwanda "},
      {name: " LC - Saint Lucia ", value: " LC - Saint Lucia "},
      {name: " WS - Samoa ", value: " WS - Samoa "},
      {name: " SM - San Marino ", value: " SM - San Marino "},
      {name: " SA - Saudi Arabia ", value: " SA - Saudi Arabia "},
      {name: " SN - Senegal ", value: " SN - Senegal "},
      {name: " SC - Seychelles ", value: " SC - Seychelles "},
      {name: " SL - Sierra Leone ", value: " SL - Sierra Leone "},
      {name: " SG - Singapore ", value: " SG - Singapore "},
      {name: " SK - Slovakia (Slovak Rep) ", value: " SK - Slovakia (Slovak Rep) "},
      {name: " SI - Slovenia ", value: " SI - Slovenia "},
      {name: " SB - Solomon Islands ", value: " SB - Solomon Islands "},
      {name: " SO - Somalia ", value: " SO - Somalia "},
      {name: " ZA - South Africa ", value: " ZA - South Africa "},
      {name: " GS - South Georgia and South Sandwich Islands ", value: " GS - South Georgia and South Sandwich Islands "},
      {name: " SU - Soviet Union ", value: " SU - Soviet Union "},
      {name: " ES - Spain ", value: " ES - Spain "},
      {name: " LK - Sri Lanka ", value: " LK - Sri Lanka "},
      {name: " SH - St. Helena ", value: " SH - St. Helena "},
      {name: " PM - St. Pierre & Miquelon ", value: " PM - St. Pierre & Miquelon "},
      {name: " ST - St. Tome and Principe ", value: " ST - St. Tome and Principe "},
      {name: " KN - St.Kitts Nevis Anguilla ", value: " KN - St.Kitts Nevis Anguilla "},
      {name: " VC - St.Vincent & Grenadines ", value: " VC - St.Vincent & Grenadines "},
      {name: " SD - Sudan ", value: " SD - Sudan "},
      {name: " SR - Suriname ", value: " SR - Suriname "},
      {name: " SJ - Svalbard & Jan Mayen Islands ", value: " SJ - Svalbard & Jan Mayen Islands "},
      {name: " SZ - Swaziland ", value: " SZ - Swaziland "},
      {name: " SE - Sweden ", value: " SE - Sweden "},
      {name: " CH - Switzerland ", value: " CH - Switzerland "},
      {name: " SY - Syria ", value: " SY - Syria "},
      {name: " TJ - Tadjikistan ", value: " TJ - Tadjikistan "},
      {name: " TW - Taiwan ", value: " TW - Taiwan "},
      {name: " TZ - Tanzania ", value: " TZ - Tanzania "},
      {name: " TH - Thailand ", value: " TH - Thailand "},
      {name: " TG - Togo ", value: " TG - Togo "},
      {name: " TK - Tokelau ", value: " TK - Tokelau "},
      {name: " TO - Tonga ", value: " TO - Tonga "},
      {name: " TT - Trinidad & Tobago ", value: " TT - Trinidad & Tobago "},
      {name: " TN - Tunisia ", value: " TN - Tunisia "},
      {name: " TR - Turkey ", value: " TR - Turkey "},
      {name: " TM - Turkmenistan ", value: " TM - Turkmenistan "},
      {name: " TC - Turks & Caicos Islands ", value: " TC - Turks & Caicos Islands "},
      {name: " TV - Tuvalu ", value: " TV - Tuvalu "},
      {name: " UG - Uganda ", value: " UG - Uganda "},
      {name: " UA - Ukraine ", value: " UA - Ukraine "},
      {name: " AE - United Arab Emirates ", value: " AE - United Arab Emirates "},
      {name: " UK - United Kingdom ", value: " UK - United Kingdom "},
      {name: " UY - Uruguay ", value: " UY - Uruguay "},
      {name: " UM - US Minor outlying Islands ", value: " UM - US Minor outlying Islands "},
      {name: " UZ - Uzbekistan ", value: " UZ - Uzbekistan "},
      {name: " VU - Vanuatu ", value: " VU - Vanuatu "},
      {name: " VA - Vatican City State ", value: " VA - Vatican City State "},
      {name: " VE - Venezuela ", value: " VE - Venezuela "},
      {name: " VN - Vietnam ", value: " VN - Vietnam "},
      {name: " VG - Virgin Islands (British) ", value: " VG - Virgin Islands (British) "},
      {name: " VI - Virgin Islands (US) ", value: " VI - Virgin Islands (US) "},
      {name: " WF - Wallis & Futuna Islands ", value: " WF - Wallis & Futuna Islands "},
      {name: " EH - Western Sahara ", value: " EH - Western Sahara "},
      {name: " YE - Yemen ", value: " YE - Yemen "},
      {name: " YU - Yugoslavia ", value: " YU - Yugoslavia "},
      {name: " ZR - Zaire ", value: " ZR - Zaire "},
      {name: " ZM - Zambia ", value: " ZM - Zambia "},
      {name: " ZW - Zimbabwe", value: " ZW - Zimbabwe"}
    ]
  }




